import { Box, Text } from "@chakra-ui/react";
import { COLORS, RADIUS } from "../../theme/dashboardTokens";

// EG-38 (passo 3 BI) — KPI card padrão do admin (mesmo do form).
export default function KpiCard({ label, value, hint, color = COLORS.ink }) {
  return (
    <Box bg={COLORS.surface} borderRadius={RADIUS.card} p="20px">
      <Text fontSize="12px" color={COLORS.inkMuted} mb="6px">
        {label}
      </Text>
      <Text fontSize="26px" fontWeight={700} color={color} lineHeight="1.1">
        {value}
      </Text>
      {hint && (
        <Text fontSize="12px" color={COLORS.inkMuted} mt="4px">
          {hint}
        </Text>
      )}
    </Box>
  );
}
